export const BERA_REPORT_VERSION = {
	V1: 1,
	V2: 2
} as const;

export type BeraReportVersion = (typeof BERA_REPORT_VERSION)[keyof typeof BERA_REPORT_VERSION];
